var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    fillRule: "evenodd",
    d: "m18.663 7.7.44-.132a.692.692 0 0 1 .873.835l-.277 1.211-.278 1.212a.692.692 0 0 1-1.149.352l-.905-.852-.904-.85a.698.698 0 0 1 .269-1.18l.342-.106a6.353 6.353 0 0 0-5.07-2.553A6.372 6.372 0 0 0 6.046 9.81c-.025.08-.052.159-.08.236l-.05.148a.805.805 0 0 1-.913.565c-.473-.082-.791-.565-.652-1.023.048-.164.106-.327.163-.49 1.393-3.815 5.534-6.106 9.666-4.952 1.867.532 3.424 1.784 4.483 3.404ZM5.337 16.3l-.44.132a.69.69 0 0 1-.872-.827l.277-1.211.285-1.22a.692.692 0 0 1 1.15-.351l.904.85.905.852a.698.698 0 0 1-.27 1.178l-.342.107a6.353 6.353 0 0 0 5.07 2.553 6.361 6.361 0 0 0 5.95-4.174c.05-.122.09-.253.13-.384a.805.805 0 0 1 .913-.565c.473.082.791.565.653 1.023-.05.164-.106.327-.163.491-1.394 3.814-5.535 6.106-9.667 4.952-1.867-.532-3.424-1.785-4.483-3.405Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA8F4E",
    d: "M14.198 13.129a1.665 1.665 0 0 0-1.053-1.554l-1.65-.66A.474.474 0 0 1 11.67 10h1.627a.6.6 0 1 0 0-1.2h-.4a.2.2 0 0 1-.2-.2v-.2a.601.601 0 0 0-1.2 0v.24a.199.199 0 0 1-.16.194 1.674 1.674 0 0 0-.288 3.195l1.651.66a.474.474 0 0 1-.176.912h-1.628a.6.6 0 1 0 0 1.2h.4a.2.2 0 0 1 .2.2v.2a.6.6 0 1 0 1.201 0v-.24a.199.199 0 0 1 .16-.195 1.68 1.68 0 0 0 1.34-1.637Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionActive);
export default __webpack_public_path__ + "static/media/subscription-active.11b3b6738c73cb8dab9d1a72711ab3c3.svg";
export { ForwardRef as ReactComponent };